// extracted by mini-css-extract-plugin
export default {"fixedBox":"styles_fixedBox__0UT18","fixed":"styles_fixed__9CLGr","fixedChecked":"styles_fixedChecked__XYwmu","oddContainer":"styles_oddContainer__0R-co"};